// src/pages/Overview.jsx
import React, { useState, useEffect } from "react"
import { Box, Typography, CircularProgress, Alert } from "@mui/material"
import PharmacyDataGrid from "../components/PharmacyDataGrid"
import { phappsRequest } from "../services/apiService"
import { PHARMACY_HALO_COLORS } from "../config/colors"
import { API_PATHS } from "../config/apiConstants"

const Overview = () => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchMainData = async () => {
      try {
        setLoading(true)
        setError(null)
        
        const response = await phappsRequest(
          API_PATHS.MAIN_DATA,
          "GET"
        )
        if (response && response.MainData && response.MainData.pharmacyData) {
          setData(response)
        } else {
          setError("Failed to fetch pharmacy data")
        }
      } catch (err) {
        console.error("Error fetching MainData:", err)
        setError("Error fetching pharmacy data. Please try again.")
      } finally {
        setLoading(false)
      }
    }

    fetchMainData()
  }, [])

  if (loading) {
    return (
      <Box className="flex items-center justify-center h-64">
        <Box className="text-center">
          <CircularProgress 
            size={60} 
            sx={{ color: PHARMACY_HALO_COLORS.BLUE, mb: 2 }} 
          />
          <Typography variant="h6" color="textSecondary">
            Loading pharmacy data...
          </Typography>
        </Box>
      </Box>
    )
  }

  if (error) {
    return (
      <Box className="flex items-center justify-center h-64">
        <Alert 
          severity="error" 
          sx={{ 
            maxWidth: 600,
            '& .MuiAlert-icon': { color: PHARMACY_HALO_COLORS.RED }
          }}
        >
          <Typography variant="h6" className="mb-2">
            {error}
          </Typography>
          <Typography variant="body2">
            Please check your connection and try again. If the problem persists, contact support.
          </Typography>
        </Alert>
      </Box>
    )
  }

  if (!data || !data.MainData || !data.MainData.pharmacyData) {
    return (
      <Box className="flex items-center justify-center h-64">
        <Alert 
          severity="warning" 
          sx={{ 
            maxWidth: 600,
            '& .MuiAlert-icon': { color: PHARMACY_HALO_COLORS.YELLOW }
          }}
        >
          <Typography variant="h6" className="mb-2">
            No pharmacy data available
          </Typography>
          <Typography variant="body2">
            There are currently no pharmacies in the system or the data is unavailable.
          </Typography>
        </Alert>
      </Box>
    )
  }

  return (
    <Box className="space-y-4">
      <Typography 
        variant="h3" 
        className="font-bold mb-6" 
        style={{ color: PHARMACY_HALO_COLORS.BLUE }}
      >
      </Typography>
      
      
      <PharmacyDataGrid data={data} />
    </Box>
  )
}

export default Overview
